import { all, put, select, takeEvery } from 'redux-saga/effects';
import actions from '../actions';

export function* ADD({ payload }) {
  const { cart } = yield select();
  yield put({
    type: actions.cart.SET_STATE,
    payload: [...cart, payload]
  });
}

export function* UPDATE({ payload }) {
  const { cart } = yield select();
  const index = cart.findIndex(orderItem => orderItem.key === payload.key);
  payload.quantity > 0
    ? yield put({
      type: actions.cart.SET_STATE,
      payload: [...cart.slice(0, index), payload, ...cart.slice(index + 1)]
    })
    : yield put({
      type: actions.cart.SET_STATE,
      payload: [...cart.slice(0, index), ...cart.slice(index + 1)]
    });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.cart.ADD, ADD),
    takeEvery(actions.cart.UPDATE, UPDATE)
  ]);
}
